<script>
    import Typing from "./TypingAnimation.svelte";
    import ParticleMorph from "./ParticleMorph.svelte";

    export let handleEventClick;
    export let navigate;

    let clickTarget = Math.floor(Math.random() * 5) + 3; // between 3 and 7
    let clicksLeft = clickTarget;
    let showEasterEgg = false;

    function handleEasterEggClick() {
        if (clicksLeft > 1) {
            clicksLeft -= 1;
        } else {
            showEasterEgg = true;
        }
    }

    let eggClicks = Math.floor(Math.random() * 3) + 3; // 3–5 clicks
    let eggRevealed = false;

    function handleEasterEggReveal() {
        if (eggClicks > 1) {
            eggClicks -= 1;
        } else {
            eggRevealed = true;
        }
    }
</script>

<div class="home-container">
    <ParticleMorph />

    <section>
        <div class="content">
            <h2>Empowering Tomorrow's Tech Leaders</h2>
            <p>
                We're a student-driven community for anyone passionate about
                technology. Attend workshops, join projects, and collaborate
                with peers to grow your skills and network.
            </p>
            <div class="navigation-links">
                <button class="cta-button" on:click={() => navigate("about")}>Learn More About Us</button>
            </div>
        </div>
    </section>

    <section>
        <div class="content">
            <h2>Artificial Intelligence</h2>
            <p>
                Build the future of intelligent systems. Learn machine learning,
                computer vision, and NLP through hands-on workshops.
            </p>
        </div>
    </section>

    <section>
        <div class="content">
            <h2>Quantum Computing</h2>
            <p>
                Get introduced to quantum concepts and real-world applications
                through talks and demos—no PhD required. Just curiosity.
            </p>
        </div>
    </section>

    <section>
        <div class="content">
            <h2>Software Development</h2>
            <p>
                Build real-world skills in software development—whether it's
                your first website or your next side project.
            </p>
            <button class="cta-button" on:click={() => navigate("officers")}>Meet Our Leaders</button>
            <button class="cta-button" on:click={() => navigate("alumni")}>See Our Alumni</button>
        </div>
    </section>

    <section>
        <div class="content">
            <h1>Explore Tech</h1>
            <p>
                Whether you're just starting or already experienced, ACM is your
                launchpad. Discover new fields, build your portfolio, and find
                your people.
            </p>
            <div class="navigation-links">
                <button
                    on:click={() => navigate("join")}
                    class="cta-button">Join ACM</button
                >
                <button
                    on:click={() => navigate("contact")}
                    class="cta-button">Reach Out</button
                >
            </div>
        </div>
    </section>
</div>

<header>
    <div class="header-content">
        <div class="header-text">
            <h1>UMD's Association for Computing Machinery</h1>
            <h2>
                For over 50 years, ACM at the University of Maryland has been
                the tech hub for coders, creators, and innovators. Our inclusive
                community empowers students to grow through workshops,
                hackathons, research, and mentorship—no sorting hats required!
            </h2>
            <h2>⟨<Typing /></h2>
        </div>
        <a href="/assets/roomfilled.jpg" target="_blank" class="image-link">
            <img
                src="/assets/roomfilled.jpg"
                alt="A filled room with students at ACM"
                class="header-image"
            />
            <h3 class="view-full-image-text">View Full Image</h3>
        </a>
    </div>
</header>

<nav>
    <div>
        <a
            href="https://discord.com/invite/4HkYzUpN67"
            target="_blank"
            class="icon-container"
        >
            <img
                src="/assets/icons/discord-white-icon.png"
                alt="Discord Icon"
                class="icon"
            />
        </a>
        <a
            href="https://github.com/acm-umd"
            target="_blank"
            class="icon-container"
        >
            <img
                src="/assets/icons/github-mark-white.svg"
                alt="GitHub Icon"
                class="icon"
            />
        </a>
        <a
            href="https://www.reddit.com/user/ACM_UMD/"
            target="_blank"
            class="icon-container"
        >
            <img
                src="/assets/icons/reddit-icon-white.svg"
                alt="Reddit Icon"
                class="icon"
            />
        </a>
    </div>
    <div>
        <a
            href="https://www.instagram.com/acm.umd/"
            target="_blank"
            class="icon-container"
        >
            <img
                src="/assets/icons/instagram-white-icon.png"
                alt="Insta Icon"
                class="icon"
            />
        </a>
        <a
            href="https://www.linkedin.com/groups/12988736/"
            target="_blank"
            class="icon-container"
        >
            <img
                src="/assets/icons/linkedin-icon-white.svg"
                alt="Linkedin Icon"
                class="icon"
            />
        </a>
        <a
            href="https://terplink.umd.edu/organization/acm"
            target="_blank"
            class="icon-container"
        >
            <img
                src="/assets/icons/terplink-logo.png"
                alt="Terplink Icon"
                class="icon-terplink"
            />
        </a>
    </div>
</nav>

<div class="container">
    <section class="announcements" style="min-height: 0;">
        <h2>Announcements</h2>
        <ul>
            <li>
                <button
                    on:click={handleEventClick}
                    style="
                  background: transparent;
                  border: none;
                  color: inherit;
                  font: inherit;
                  cursor: pointer;
                  padding: 0;
                  text-align: left;
                "
                >
                    Want to join us this year? Check out upcoming events »
                </button>
            </li>
            <li>
                We welcome your ideas for future workshops! Please feel free to
                email us your suggestions.
            </li>
            <li>
                {#if !eggRevealed}
                    <button
                        class="easter-egg-button2"
                        on:click={handleEasterEggReveal}
                        style="margin-top: 0.5rem;"
                    >
                        Click Me ({eggClicks})
                    </button>
                {:else}
                    <span class="easter-egg-reveal">
                        🥚 Congrats! You found your first Easter egg. More are
                        hidden — Joshua Zheng, 2025!
                    </span>
                {/if}
            </li>
        </ul>
    </section>

    <section class="opportunities" style="min-height: 0;">
        <h2>Events, Opportunities, and More</h2>
        <ul>
            <li>
                Mentor for the ACM Mentorship Program – DM a leader on Discord
            </li>
            <li>Apply for the ACM Exec Board – Officer roles open</li>
            <li>Attend our upcoming ACM Workshop</li>
            <li>Free student VPS expansion – now available</li>
        </ul>
    </section>
</div>
<div class="easter-egg-container">
    {#if !showEasterEgg}
        <button class="easter-egg-button" on:click={handleEasterEggClick}>
            {clicksLeft}?
        </button>
    {:else}
        <p class="easter-egg-text">
            🎉 Joshua Zheng made this — congrats, you found an Easter egg! 🥚
        </p>
    {/if}
</div>

<style>
    @keyframes slideInBottom {
        0% {
            transform: translateY(100%); /* Start from below the screen */
            opacity: 0; /* Start invisible */
        }
        100% {
            transform: translateY(0); /* End at original position */
            opacity: 1; /* End visible */
        }
    }

    @keyframes slideInLeft {
        0% {
            transform: translateX(-100%); /* Start off-screen */
            opacity: 0; /* Start invisible */
        }
        10% {
            opacity: 0; /* Remain invisible during the delay */
        }
        100% {
            transform: translateX(0); /* Slide to original position */
            opacity: 1; /* Fade in */
        }
    }

    header {
        animation: slideInBottom 1.5s ease forwards;
        background: linear-gradient(to right, rgba(248, 85, 88, 0.75), #cbaaf4);
        padding: 10px;
        color: #ffffff;
        border-radius: 20px;
    }

    .header-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .header-text {
        animation: slideInLeft 1.5s ease forwards;
        text-align: left;
    }

    .header-image {
        max-width: 80%;
        height: auto;
        margin: 1rem;
        border-radius: 20px;
    }
    a:hover .header-image {
        transform: scale(1.05);
    }
    .image-link {
        text-align: center;
    }

    .view-full-image-text {
        color: purple;
        margin-top: 10px;
        text-decoration: underline;
        text-decoration-color: purple;
    }
    nav {
        padding-left: 20%;
        padding-right: 20%;
        margin: 20px;
        text-align: center;
        justify-content: center;
    }

    nav a {
        margin: 10px;
        text-decoration: none;
        color: #ffd520;
        font-weight: bold;
        padding: 10px;
    }

    .icon {
        max-width: 40px;
        max-height: 40px;
    }
    .icon-terplink {
        max-width: 40px;
        max-height: 40px;
    }
    .container {
        display: flex;
        justify-content: space-between;
        padding: 20px;
        gap: 20px;
    }

    .announcements,
    .opportunities {
        flex: 1;
        padding: 5px;
        border-radius: 10px;
        box-sizing: border-box;
    }

    .announcements {
        background: linear-gradient(to left, #ff7676, #f73b51);
        color: #000000;
    }

    .announcements h2 {
        color: #000;
    }

    .opportunities {
        background: linear-gradient(to right, #ff8c8c, #b48cff);
        color: #000000;
    }

    .opportunities h2 {
        color: #000;
    }
    .announcements li {
        padding: 0.3vw;
        cursor: pointer;
        transition: background-color 0.3s ease;
        background: transparent;
        border: none;
        width: 100%;
        text-align: left;
    }

    .announcements li:hover {
        background-color: rgba(255, 255, 255, 0.435);
        color: #000;
    }

    .easter-egg-button {
        padding: 0.3rem 0.6rem;
        border: none;
        border-radius: 6px;
        background-color: transparent;
        color: rgba(255, 255, 255, 0.3);
        font-size: 0.8rem;
        font-weight: normal;
        cursor: pointer;
        transition: all 0.2s ease;
        box-shadow: none;
        opacity: 0.3;
    }

    .easter-egg-button:hover {
        color: #ffd520;
        opacity: 0.7;
        transform: scale(1.05);
        background-color: rgba(255, 255, 255, 0.05);
    }

    .easter-egg-button2 {
        padding: 0.3rem 0.6rem;
        border: none;
        border-radius: 6px;
        background-color: #ffd520;
        color: #000;
        font-size: 0.9rem;
        cursor: pointer;
        font-weight: bold;
        transition: all 0.2s ease;
    }

    .easter-egg-button2:hover {
        background-color: #ffec70;
        transform: scale(1.05);
    }

    .easter-egg-reveal {
        font-size: 0.9rem;
        color: #fff;
        background: rgba(255, 255, 255, 0.15);
        padding: 0.5rem;
        border-radius: 6px;
        display: inline-block;
    }

    @keyframes popIn {
        0% {
            transform: scale(0.8);
            opacity: 0;
        }
        100% {
            transform: scale(1);
            opacity: 1;
        }
    }

    /* Mobile Styles */
    @media only screen and (max-width: 600px) {
        :global(body) {
            overflow-x: hidden;
        }
        header {
            background-color: #ff787a;
            padding: 10px;
            color: #ffffff;
            border-radius: 20px;
        }
        .icon {
            max-width: 8vw;
            height: auto;
        }
        .icon-terplink {
            max-width: 7vw;
            height: auto;
        }
        .header-content {
            display: flex;
            flex-direction: column-reverse;
            justify-content: space-between;
            align-items: center;
        }

        .header-text {
            text-align: left;
        }

        .header-image {
            max-width: 90vw;
            height: auto;
            margin: auto;
            border-radius: 20px;
        }

        nav {
            display: flex;
            justify-content: center;
            padding: 10px;
        }

        nav a {
            margin: 10px;
            text-decoration: none;
            color: #ffd520;
            font-weight: bold;
            display: inline-block;
        }

        .container {
            flex-direction: column;
            justify-content: space-between;
            padding: 20px;
            gap: 20px;
        }

        .announcements,
        .opportunities {
            flex: 1;
            padding: 20px;
            border-radius: 10px;
            box-sizing: border-box;
        }

        .announcements {
            background-color: #ffea8c;
            color: #000000;
        }

        .opportunities {
            background-color: #ff787a;
            color: #000000;
        }
    }

    .home-container {
        min-height: 100vh;
        width: 100%;
        position: relative;
        overflow-x: hidden;
        background: transparent;
    }

    section {
        min-height: 100vh;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 2rem;
        position: relative;
        z-index: 2;
        background: transparent;
    }

    .content {
        max-width: 800px;
        text-align: center;
        color: white;
        padding: 2rem;
        border-radius: 1rem;
        backdrop-filter: blur(10px);
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
        border: 1px solid rgba(255, 0, 0, 0.8);
        background-color: transparent;
    }

    h1 {
        font-size: 2rem;
        margin-bottom: 1.5rem;
        color: #ffffff;
        text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    }

    h2 {
        font-size: 1.5rem;
        margin-bottom: 1.5rem;
        color: #ffffff;
        text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    }

    p {
        font-size: 1.2rem;
        line-height: 1.6;
        margin-bottom: 2rem;
        color: #e0e0e0;
        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
    }

    .navigation-links {
        display: flex;
        flex-wrap: wrap;
        gap: 1rem;
        justify-content: center;
        margin-top: 2rem;
    }

    .cta-button {
        display: inline-block;
        padding: 1rem 2rem;
        background: linear-gradient(45deg, #ff6b6b, #4ecdc4);
        color: white;
        text-decoration: none;
        border-radius: 2rem;
        font-weight: bold;
        transition: all 0.3s ease;
        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
        border: none;
        cursor: pointer;
    }

    .cta-button:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
    }

    @media (max-width: 768px) {
        h1 {
            font-size: 3rem;
        }

        h2 {
            font-size: 1.5rem;
        }

        p {
            font-size: 1rem;
        }

        .content {
            padding: 1.5rem;
            margin: 1rem;
            background-color: rgba(
                0,
                0,
                0,
                0.4
            ); /* semi-transparent dark background */
            border: 1px solid rgba(255, 255, 255, 0.1);
            box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3); /* keep shadow */
            border-radius: 1rem;
            color: white;
        }

        .navigation-links {
            flex-direction: column;
            align-items: center;
        }

        .cta-button {
            width: 100%;
            max-width: 300px;
            margin: 0.5rem 0;
        }
    }
</style>
